import { render, staticRenderFns } from "./CargaTable.vue?vue&type=template&id=8b083356&scoped=true"
import script from "./CargaTable.vue?vue&type=script&lang=ts"
export * from "./CargaTable.vue?vue&type=script&lang=ts"
import style0 from "./CargaTable.vue?vue&type=style&index=0&id=8b083356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b083356",
  null
  
)

export default component.exports